import { BlobReader, BlobWriter, ZipReader } from '@zip.js/zip.js'

export const unzipFile = file =>
  new Promise((resolve, reject) => {
    const unzip = async () => {
      try {
        const reader = new BlobReader(file)
        const zipReader = new ZipReader(reader)
        const entries = await zipReader.getEntries()
        resolve(entries)
      } catch (err) {
        reject(err)
      }
    }
    unzip()
  })

export const blobToDataUrl = blob => URL.createObjectURL(blob)

export const fileToBlob = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    // Read the file as an array buffer
    reader.onloadend = () => {
      const arrayBuffer = reader.result
      const blob = new Blob([arrayBuffer], { type: file.type })
      resolve(blob) // Resolve the blob
    }

    reader.onerror = () => {
      reject(new Error('Error reading file.'))
    }

    reader.readAsArrayBuffer(file) // Read the file
  })

export const fileToDataUrl = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })

const loadZipFile = async file => unzipFile(await fileToBlob(file))

export const getPdfUrlFromPkg = async file =>
  new Promise((resolve, reject) => {
    if (file?.name.endsWith('.pkg')) {
      loadZipFile(file)
        .then(entries => {
          let found = false
          entries.forEach(async entry => {
            if (
              entry.filename.startsWith('Reports/') &&
              entry.filename.endsWith('.pdf')
            ) {
              found = true
              try {
                const blob = await entry.getData(
                  new BlobWriter('application/pdf'),
                )
                const url = URL.createObjectURL(blob)
                resolve(url)
              } catch (entryError) {
                reject(
                  new Error(`Error reading zip file: ${entryError.message}`),
                )
              }
            }
          })
          if (!found) reject(new Error('Pkg file does not contain a pdf file.'))
        })
        .catch(err => {
          reject(new Error(`Error unzipping file: ${err.message}`))
        })
    } else {
      reject(new Error('Please select a valid PKG file.'))
    }
  })

export const fetchBlobToDataUrl = url =>
  new Promise((resolve, reject) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader()
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.onerror = () => {
          reject(new Error('Error reading blob as data URL.'))
        }
        reader.readAsDataURL(blob)
      })
      .catch(err => {
        reject(new Error(`Error fetching blob: ${err.message}`))
      })
  })

export const dataURLToFile = (dataURL, fileName) => {
  const arr = dataURL.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  // eslint-disable-next-line no-plusplus
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], fileName, { type: mime })
}
